<template>
    <div style="width: 100%;height: 100%;">
        <div style="width: 100%;background-color: #fff;">
            <div class="headerBox">
                <div class="hearderContentBox">
                    <div class="titleBox">
                        <div class="logoBox" @click="this.$router.push('/')">
                            <img src="../assets/logo/logo.png" alt="">
                        </div>
                    </div>
                    <div class="right" style="width: 113px;position: relative;position: relative;left:80px;">
                        <div class="home" @click="this.$router.push('/')">
                            <img style="width: 13px;margin-bottom: 3px;" src="@/assets/home/logon-icon-01.png" alt="">
                            返回首页
                        </div>
                    </div>
                    <div class="right">
                        <template v-if="!user.phoneNumber">
                            <div class="login" @click="this.$router.push('/login?id=user')">
                                <img src="@/assets/home/home-icon.png" alt="">
                                登录
                            </div>
                            <div class="register" @click="this.$router.push('/register')">注册</div>
                        </template>
                        <template v-else>
                            <div class="rightBox" v-if="user.phoneNumber">
                                <a-dropdown>
                                    <template #overlay>
                                        <a-menu style="margin-top:10px">
                                            <a-menu-item key="3">
                                                <a @click="onLogout()">
                                                    <PoweroffOutlined /> 退出登录
                                                </a>
                                            </a-menu-item>
                                        </a-menu>
                                    </template>
                                    <a class="ant-dropdown-link"
                                       style="color: #104460;"
                                       @click="islogin">
                                        <img  style="width: 15px;height: 15px;margin-top:-3px;" src="@/assets/img/login.png" alt=""> {{
                                            user.phoneNumber
                                        }}
                                    </a>
                                </a-dropdown>
                            </div>
                        </template>
                    </div>
                </div>

            </div>

        </div>
        <div style="width: 100%;background-color: #fff;margin-bottom: 40px;">
            <div class="floatBox">
                <div class="textBox">
                    <div class="text">注册账号</div>
                </div>
                <div class="midBox">
                    <div class="midFloatBox">
                        <div class="tabBox">
                            <a-steps :current="current"  type="navigation" :style="stepStyle">
                                <a-step status="wait" title="① 用户选择" />
                                <a-step status="wait" title="② 账号设置" />
                                <a-step status="wait" title="③ 注册成功" />
                            </a-steps>
                            <div v-if="current == '0'" class="select-role">
                                <div class="role-box">
                                    <div class="item"
                                         :class="item.id == form.roleId ? 'item-active': ''"
                                         v-for="(item,index) in roleList" @click="roleSelect(item)" :key="index">
                                        <img class="img" v-if="item.id != form.roleId" :src="item.url" alt="">
                                        <img class="img1" v-else :src="item.url1" alt="">
                                        <div class="text">{{ item.text }}</div>
                                    </div>
                                </div>
                                <a-button class="button" size="large"  @click="next">
                                    下一步
                                </a-button>
                            </div>
                            <div v-if="current == '2'" class="success-div">
                                <a-result
                                    status="success"
                                    title="恭喜，注册成功"
                                >
                                    <template #extra>
                                        <a-button class="button" @click="$router.push('/')">去登录</a-button>
                                    </template>
                                </a-result>
                            </div>
                            <a-form v-if="current == '1'" class="login-form" ref="ruleForm" layout="horizontal" :model="form" :rules="rules">
                                <a-form-item :label-col="{ style: 'width:90px' }" name="roleId" label="角色">
                                    <single-select size="large" placeholder="请选择角色" v-model:value="form.roleId"
                                                   :options="optionsRoleTreeList" titleName="roleName" valueName="id"
                                                   @change="handleChange"/>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:90px' }"
                                             v-if="form.roleId != '004' && form.roleId != '013'" name="username"
                                             label="姓名">
                                    <a-input size="large" v-model:value="form.username" placeholder="请输入姓名">
                                        <template #prefix>
                                            <user-outlined class="tc-gray"/>
                                        </template>
                                    </a-input>

                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:90px' }" v-if="form.roleId == '014'"
                                             name="idCard" label="身份证号">
                                    <a-input size="large" v-model:value="form.idCard" placeholder="请输入身份证号" @blur="checkIdCardUnique">
                                        <template #prefix>
                                            <IdcardOutlined class="tc-gray"/>
                                        </template>
                                    </a-input>
                                </a-form-item>

<!--                                <a-form-item :label-col="{ style: 'width:90px' }" v-if="form.roleId == '014'"
                                             name="institution" label="工作单位">
                                    <a-input size="large" v-model:value="form.institution" placeholder="请输入工作单位">
                                        <template #prefix>
                                            <BankOutlined class="tc-gray"/>
                                        </template>
                                    </a-input>
                                </a-form-item>-->

<!--                                <a-form-item :label-col="{ style: 'width:90px' }" v-if="form.roleId == '014'"
                                             name="positional" label="职称">
                                    <a-input size="large" v-model:value="form.positional" :autocomplete="false"
                                             placeholder="请输入职称">
                                        <template #prefix>
                                            <VerifiedOutlined class="tc-gray"/>
                                        </template>
                                    </a-input>
                                </a-form-item>-->

                                <a-form-item :label-col="{ style: 'width:160px;margin-left: -70px;' }"
                                             v-if="form.roleId == '004' || form.roleId == '013'"
                                             name="oraganizationCode" label="统一社会信用代码">
                                    <a-input @blur="subCompanyCode" size="large" v-model:value="form.oraganizationCode"
                                             placeholder="请输入统一社会信用代码">
                                        <template #prefix>
                                            <KeyOutlined class="tc-gray"/>
                                        </template>
                                        <div>（用户名为统一社会信用代码，密码可通过手机号找回）</div>
                                    </a-input>
                                    <div style="color:#ff585a;">（用户名为统一社会信用代码，密码可通过手机号找回）</div>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:90px' }"
                                             v-if="form.roleId == '004' || form.roleId == '013'" name="companyName"
                                             :label="companyName+'名称'">

                                    <!-- @blur="subCompanyName" -->
                                    <a-input @blur="subCompanyName" size="large" v-model:value="form.companyName"
                                             :placeholder="'请输入'+companyName+'名称'">
                                        <template #prefix>
                                            <user-outlined class="tc-gray"/>
                                        </template>
                                    </a-input>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:90px' }" v-if="form.roleId == '004'"
                                             name="affiliatedPark"
                                             label="所属园区">
                                    <single-select size="large" placeholder="请选择所属园区"
                                                   v-model:value="form.affiliatedPark"
                                                   :options="options" titleName="baseName" valueName="id" @change="getChildrenInnovationBaseInfo"/>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:90px' }" v-if="form.roleId == '004'"
                                             name="baseId"
                                             label="所属载体">
                                  <single-select size="large" placeholder="请选择所属载体"
                                                 v-model:value="form.baseId"
                                                 :options="options2" titleName="baseName" valueName="id"/>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:90px' }" v-if="form.roleId == '004'"
                                             name="companyDomain"
                                             label="所属领域">
                                    <DictSelect size="large" v-model:value="form.companyDomain"
                                                :dict-name="'corpbelong_type'"
                                                placeholder="请选择所属领域">
                                        <template #prefix>
                                            <ForkOutlined class="tc-gray"/>
                                        </template>
                                    </DictSelect>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:120px;margin-left: -30px;' }"
                                             v-if="optionsTreeList" name="functionId" label="所属服务机构">
                                    <single-select size="large" v-model:value="form.functionId"
                                                   :options="optionsTreeList" titleName="name"
                                                   valueName="id"/>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:90px' }"
                                             v-if="form.roleId == '004' || form.roleId == '013'" name="addressStr"
                                             :label="companyName+'地址'">
                                    <a-input :readonly="true" size="large" v-model:value="form.addressStr"
                                             placeholder="请选择地址"
                                             @click="showMap">
                                        <template #addonAfter>
                                            <p style="cursor: pointer;" @click="showMap">选择地址</p>
                                        </template>
                                    </a-input>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:90px' }" name="newpassword" label="密码">
                                    <a-input-password size="large" v-model:value="form.newpassword" placeholder="请输入密码">
                                        <template #prefix>
                                            <LockOutlined class="tc-gray"/>
                                        </template>
                                    </a-input-password>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:90px' }" style="position:relative"
                                             name="password" label="确认密码">
                                    <a-input-password @change="getNew" size="large" v-model:value="form.password"
                                                      placeholder="请再次输入密码">
                                        <template #prefix>
                                            <LockOutlined class="tc-gray"/>
                                        </template>
                                    </a-input-password>
                                    <ExclamationOutlined v-if="pwOk == false"
                                                         style="color:#f5222d;position:absolute;right:-20px;top:12px"/>
                                    <CheckOutlined v-if="pwOk"
                                                   style="color:green;position:absolute;right:-20px;top:12px"/>
                                </a-form-item>
                                <!-- 短信验证 -->
                                <a-form-item :label-col="{ style: 'width:120px;margin-left: -30px' }" name="legalName"
                                             label="法定代表人" v-if="form.roleId == '013'">
                                  <a-input size="large" style="width:100%;position:relative"
                                           v-model:value="form.legalName"
                                           placeholder="请输入法定代表人">
                                  </a-input>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:120px;margin-left: -30px' }" name="phoneNumber"
                                             label="法人手机号" v-if="form.roleId == '004' || form.roleId == '013'">
                                    <a-input size="large" style="width:100%;position:relative"
                                             v-model:value="form.phoneNumber"
                                             placeholder="请输入法人手机号">
                                        <template #prefix>
                                            <PhoneOutlined class="tc-gray"/>
                                        </template>
                                        <template #addonAfter>
                                            <a-botton style="cursor: pointer;" @click="subPhone()">{{
                                                    codeBtnWord
                                                }}
                                            </a-botton>
                                            <div class="codeBtnWordMark" ref="codeBtnWordMarkid">

                                            </div>
                                        </template>
                                    </a-input>
                                    <div style="color:#ff585a;">（必须为法人真实手机号，用于后续接收重要通知）</div>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:120px;margin-left: -30px' }" name="phoneNumber"
                                             label="账号" v-if="form.roleId != '004' && form.roleId != '013'">
                                    <a-input size="large" style="width:100%;position:relative"
                                             v-model:value="form.phoneNumber"
                                             placeholder="请输入手机号">
                                        <template #prefix>
                                            <PhoneOutlined class="tc-gray"/>
                                        </template>
                                        <template #addonAfter>
                                            <a-botton style="cursor: pointer;" @click="subPhone()">{{
                                                    codeBtnWord
                                                }}
                                            </a-botton>
                                            <div class="codeBtnWordMark" ref="codeBtnWordMarkid">

                                            </div>
                                        </template>
                                    </a-input>
                                    <div style="color:#ff585a;">（必须为真实手机号，用于后续接收重要通知）</div>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:120px;margin-left:-30px' }" name="watmal"
                                             label="手机验证码">
                                    <a-input size="large" style="width:100%" v-model:value="form.watmal"
                                             placeholder="请输入手机验证码">
                                        <template #prefix>
                                            <LockOutlined class="tc-gray"/>
                                        </template>
                                    </a-input>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:250px;margin-left: -160px;' }"
                                             style="margin-top:20px"
                                             v-if="form.roleId == '004' || form.roleId == '013'" :label="fileLabel" name="licenceFile">
                                    <file-upload v-model:value="form.licenceFile" :size="50" :isPdf="true"/>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:220px;margin-left: -130px;' }"
                                             style="margin-top:20px"
                                             v-if="form.roleId == '004' || form.roleId == '013'" label="企业法人身份证(PDF)"
                                             name="legalPersonCard">
                                    <file-upload v-model:value="form.legalPersonCard" :size="50" :isPdf="true"/>
                                </a-form-item>
<!--                                <a-form-item :label-col="{ style: 'width:250px;margin-left: -160px;' }"
                                             style="margin-top:20px"
                                             v-if="form.roleId == '014'" label="专家库成员申请表(PDF)" name="applyFile">
                                    <file-upload v-model:value="form.applyFile" :multiple="false" :count="1" :size="50"
                                                 :isPdf="true"/>
                                    <div style="margin-top: 8px" v-if="!form.applyFile">
                                        <a @click="downloadApplyFile" alt="阳泉高新区信息化项目评审专家库成员申请表">点击下载《阳泉高新区信息化项目评审专家库成员申请表》</a>
                                        <span style="color: red">填写并盖章后上传扫描文件</span>
                                    </div>
                                </a-form-item>-->
<!--                                <a-form-item :label-col="{ style: 'width:250px;margin-left: -160px;' }"
                                             style="margin-top:20px"
                                             v-if="form.roleId == '014'" label="身份证正反面(PDF)" name="idCardFile">
                                    <file-upload v-model:value="form.idCardFile" :multiple="false" :count="1" :size="50"
                                                 :isPdf="true"/>
                                </a-form-item>
                                <a-form-item :label-col="{ style: 'width:250px;margin-left: -160px;' }"
                                             style="margin-top:20px"
                                             v-if="form.roleId == '014'" label="职称证书(PDF)" name="positionalFile">
                                    <file-upload v-model:value="form.positionalFile" :multiple="false" :count="1"
                                                 :size="50" :isPdf="true"/>
                                </a-form-item>-->
                                <div style="overflow: hidden;margin-top: 30px;">
                                    <div class="btnBB">
                                        <a-button class="button1" style="margin-right: 20px;"
                                                  @click="current -= 1">上一步
                                        </a-button>
                                        <a-button class="button" html-type="submit"
                                                  :loading="confirmLoading"
                                                  @click="onSubmit">
                                            注册
                                        </a-button>
                                    </div>
                                </div>
                            </a-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a-modal v-model:visible="visible" title="企业认证承诺授权书" :maskClosable="false">
            <template #footer>
                <div>
                    <a-button type="primary" @click="handleOk">已阅读企业认证承诺授权书</a-button>
                </div>
            </template>
            <h4>本企业承诺：</h4>
            <p style="text-indent: 2em;margin: 20px 0;">
                1、本账号全权代表本单位，愿意自觉遵守国家法律、法规及相关政策，承诺在平台上的所有行为均遵守各项规章制度，如有违反，愿意为此承担相应责任。
            </p>
            <p style="text-indent: 2em;margin: 20px 0;">
                2、保证所提交的企业资料真实有效无误，对所提供材料依法承担法律责任，若有虚假、伪造等违规情况，3年内不享受高新区各类扶持政策。</p>
            <a-checkbox v-model:checked="checkedRadio">本企业对以上承诺内容确认无异议</a-checkbox>
            <p style="color:red" v-if="checkedRadioBtn">请阅读并勾选该项</p>
        </a-modal>

        <a-modal v-model:visible="visible2" title="信息化项目评审专家廉洁承诺书" :maskClosable="false">
            <template #footer>
                <div>
                    <a-button type="primary" @click="handleOk">已阅读信息化项目评审专家廉洁承诺书</a-button>
                </div>
            </template>
            <h4>本人承诺：</h4>
            <p style="text-indent: 2em;margin: 20px 0;">
                本人作为阳泉高新区信息化项目评审专家，在参加信息化项目评审工作中，严格遵循《中华人民共和国招标投标法》相关评审规定，认真执行评审规定、严格履行专家评审职责，本着公正、公平及诚实、信用的原则，在信息化项目评审过程中不受任何干扰，独立提出评审意见；同时本人将严格遵守保密纪律，不私自透露评审情况并对自己的评审意见承担责任。
            </p>
            <a-checkbox v-model:checked="checkedRadio">本人对以上承诺内容确认无异议</a-checkbox>
            <p style="color:red" v-if="checkedRadioBtn">请阅读并勾选该项</p>
        </a-modal>
        <LayoutFooter/>
        <BMapAddressSelect :defaultInfo="{ lng: addressInfo.longitude, lat: addressInfo.latitude }"
                           ref="bmapAddressSelect"
                           @confirmMapAddress="confirmMapAddress"></BMapAddressSelect>
    </div>
</template>

<script>
import {dictMixin} from "@/mixins";
import {login_mp, sys_admin, file_service, register_mp} from "@/api/adminService";
import {ls} from "@/utils/util"
import {enterpriseOperatingIncome} from "@/api/integral";
import {innovationBaseInfo} from "@/api/finance";
import {platformName} from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import axios from "axios";
import dataCheck from "@/utils/dataCheck";
import {notification} from "ant-design-vue";
import {SmileOutlined} from '@ant-design/icons-vue';
import {common, phoneCommon} from "@/api/finance"
import {h} from 'vue';
import BMapAddressSelect from "@/components/BMapAddressSelect/oldIndex";

export default {
    name: "index",
    components: {
        LayoutFooter, BMapAddressSelect
    },
    mixins: [dictMixin],
    data() {
        return {
            roleList:[
                {
                    id:'004',
                    text:'企业用户',
                    url:require('../assets/home/regiter-icon03.png'),
                    url1:require('../assets/home/regiter-icon03-selected.png'),
                },
                {
                    id:'014',
                    text:'专家用户',
                    url:require('../assets/home/regiter-icon01.png'),
                    url1:require('../assets/home/regiter-icon01-selected.png'),
                }, {
                    id:'013',
                    text:'事业单位/国企',
                url:require('../assets/home/regiter-icon02.png'),
                url1:require('../assets/home/regiter-icon02-selected.png'),
                }, {
                id:'005',
                text:'服务机构',
                url:require('../assets/home/regiter-icon04.png'),
                url1:require('../assets/home/regiter-icon04-selected.png'),
            }, {
                id:'007',
                text:'金融机构',
                url:require('../assets/home/regiter-icon05.png'),
                url1:require('../assets/home/regiter-icon05-selected.png'),
            }, {
                id:'008',
                text:'金融顾问',
                url:require('../assets/home/regiter-icon06.png'),
                url1:require('../assets/home/regiter-icon06-selected.png'),
            }, {
                id:'009',
                text:'投资人',
                url:require('../assets/home/regiter-icon07.png'),
                url1:require('../assets/home/regiter-icon07-selected.png'),
            }, {
                id:'011',
                text:'投资机构',
                url:require('../assets/home/regiter-icon08.png'),
                url1:require('../assets/home/regiter-icon08-selected.png'),
            }, {
                    id:'010',
                    text:'技术经理人',
                    url:require('../assets/home/regiter-icon09.png'),
                    url1:require('../assets/home/regiter-icon09-selected.png'),
                }, {
                    id:'003',
                    text:'个人',
                    url:require('../assets/home/regiter-icon10.png'),
                    url1:require('../assets/home/regiter-icon10-selected.png'),
                }],
            stepStyle: {
                marginBottom: '60px',
                boxShadow: '0px -1px 0 0 #e8e8e8 inset',
            },
            current:0,
            isReview:false,
            visible2:false,
            registerOk: null,
            all_logo: '',
            dictNames: 'policy_type,corpbelong_type,affiliated_park',
            user: {},
            getDateId: null,
            formState: {
                user: undefined,
            },
            // 位置信息
            addressInfo: {},
            addressStr: '',
            webSiteInfo: {},
            linkData: [],
            pwOk: null,
            companyShow: null,
            options: [],
            options2: [],
            optionsRoleTreeList: null,
            optionsMechanIsmTreeList: null,
            optionsBaseTreeTreeList: null,
            optionsTreeList: null,
            code: '',
            codeLength: 4,
            inputvalue: '',
            show: false,
            showerror: false,
            checkedRadio: false,
            checkedRadioBtn: false,
            visible: false,
            isClick: true,
            platformName,
            confirmLoading: false,
            codeBtnWord: '获取短信验证码',
            waitTime: 61,
            form: {
                phoneNumber: null,
                roleId: '004',
                baseId: null,
                functionId: null,
                username: null,
                // email: null,
                newpassword: null,
                password: null,
                companyName: null,
                companyDomain: null,
                affiliatedPark: null,
                watmal: null,
                addressStr: null,
                // captcha: null,
            },
            rules: {
                phoneNumber: [
                    dataCheck.required({msg: '手机号不能为空'}), dataCheck.mobile_phone
                ],
                roleId: [
                    dataCheck.required({msg: '请选择角色分类'}),
                ],
                functionId: [
                    dataCheck.required({msg: '请选择角色'}),
                ],
                username: [
                    dataCheck.required({msg: '用户名不能为空'}),
                ],
                baseId:[],
                // email: [
                // 	dataCheck.required({ msg: '邮箱不能为空' }), dataCheck.email
                // ],
                newpassword: [
                    dataCheck.required({msg: '新密码不能为空'}),
                    dataCheck.password,
                ],
                password: [
                    dataCheck.required({msg: '确认密码不能为空'}),
                ],
                oraganizationCode: [dataCheck.required({msg: '统一社会信用代码不能为空'}), dataCheck.oraganizationCode],
                companyName: [
                    dataCheck.required({msg: '企业名称不能为空'}),
                ],
                companyDomain: [dataCheck.required({msg: '所属领域不能为空'})],
                affiliatedPark: [dataCheck.required({msg: '所属园区不能为空'})],
                watmal: [
                    dataCheck.required({msg: '验证码不能为空'}),
                ],
                licenceFile: [dataCheck.required({msg: '营业执照不能为空'})],
                legalPersonCard: [dataCheck.required({msg: '企业法人身份证不能为空'})],
                captcha: [dataCheck.required({msg: '验证码不能为空'})],
                addressStr: [dataCheck.required({msg: '企业地址不能为空'})],
                idCard: [dataCheck.required({msg: '身份证号不能为空'}), dataCheck.id_num],
                positional: [dataCheck.required({msg: '职称不能为空'})],
                institution: [dataCheck.required({msg: '工作单位不能为空'})],
                idCardFile: [dataCheck.required({msg: '请上传身份证正反面'})],
                positionalFile: [dataCheck.required({msg: '请上传职称证书'})],
                applyFile: [dataCheck.required({msg: '请上传专家库成员申请表'})],
                legalName: [dataCheck.required({msg: '请输入法定代表人'})]
            },
            captchaPath: '',
            redirectPath: '/',
            screenWidth:''
        }
    },
    computed: {
        companyName: function () {
            return this.form.roleId == '004' ? "企业" : "单位"
        },
        fileLabel: function () {
            return this.form.roleId == '013' ? "法人证书/营业执照(PDF)" : "营业执照(PDF)"
        }

    },

    methods: {
        roleSelect(item){
            this.form.roleId = item.id
        },
        next(){
            this.current += 1
        },
        downloadApplyFile(){
            axios({
                methods: 'get',
                url: file_service.download + 'a1r1ueave9xsp5eyfhhv|阳泉高新区信息化项目评审专家库成员申请表.docx',
            }).then(() => {
                const link = document.createElement("a"); // 创建a标签
                link.href = file_service.download + "a1r1ueave9xsp5eyfhhv|阳泉高新区信息化项目评审专家库成员申请表.docx";
                link.target = '_blank';
                link.download = decodeURIComponent("阳泉高新区信息化项目评审专家库成员申请表.docx");// 文件重命名，若无需重命名，将该行删去
                link.click();
            })
        },
        useExpertByQueryStr(){
            if (this.$route.query.role){
                this.form.roleId = this.$route.query.role
            }
            // console.log(this.$route.query.role)
        },
        getPhoneCode() {
            let that=this
            this.$refs.ruleForm
                .validate('phoneNumber')
                .then((value) => {
                    this.postAction({
                            url: phoneCommon.registerSMS,
                            params: {
                                phone: value.phoneNumber
                            }
                        }
                    ).then((res) => {
                        if (res.code == '0') {
                            this.waitTime = (res.msg * 60) + 1
                            this.waitTime--;
                            this.$refs.codeBtnWordMarkid.style.zIndex = 1
                            this.codeBtnWord = `${this.waitTime}s 后获取`;
                            let timer = setInterval(() => {
                                if (this.waitTime > 1) {
                                    this.waitTime--;
                                    this.codeBtnWord = `${this.waitTime}s 后获取`;
                                } else {
                                    clearInterval(timer);
                                    this.codeBtnWord = "获取短信验证码";
                                    this.$refs.codeBtnWordMarkid.style.zIndex = -1
                                    this.waitTime = 61;
                                }
                            }, 1000);
                            notification.success({
                                message: '验证码发送成功，请查看手机短信',
                                placement: 'topLeft',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft: `-${that.screenWidth/2-200}px`,
                                    marginTop: `${20}%`,
                                }
                            });
                        } else if (res.code == '1') {
                            notification.success({
                                message: '验证码发送失败，请稍后重新发送',
                                placement: 'topLeft',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft:  `-${that.screenWidth/2-200}px`,
                                    marginTop: `${20}%`,
                                }
                            });
                        } else if (res.code == '2') {
                            notification.success({
                                message: res.msg,
                                placement: 'topLeft',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft: `-${that.screenWidth/2-200}px`,
                                    marginTop: `${20}%`,
                                }
                            });
                        } else if (res.code == '3') {
                            notification.success({
                                message: res.msg,
                                placement: 'topLeft',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft:  `-${that.screenWidth/2-200}px`,
                                    marginTop: `${20}%`,
                                }
                            });
                        }
                    })
                })
        },
        getCode() {
            console.log(this.addressInfo)

            this.$refs.ruleForm
                .validate('email')
                .then(() => {
                    this.postSeed()
                    // this.waitTime--;
                    // this.$refs.codeBtnWordMarkid.style.zIndex = 1
                    // this.postSeed()
                    // this.codeBtnWord = `${this.waitTime}s 后获取`;
                    // let timer = setInterval(() => {
                    // 	if (this.waitTime > 1) {
                    // 		this.waitTime--;
                    // 		this.codeBtnWord = `${this.waitTime}s 后获取`;
                    // 	} else {
                    // 		clearInterval(timer);
                    // 		this.codeBtnWord = "获取验证码";
                    // 		this.$refs.codeBtnWordMarkid.style.zIndex = -1
                    // 		this.waitTime = 61;
                    // 	}
                    // }, 1000);
                })
                .catch(() => {
                })
        },
        postSeed() {
            let that=this
            this.$refs.ruleForm
                .validate('email', 'phoneNumber')
                .then((values) => {
                    this.confirmLoading = true;
                    this.postAction({
                            url: common.sendMailCode,
                            params: {
                                mail: values.email,
                                mobile: this.form.phoneNumber
                            }
                        }
                    ).then((res) => {
                        if (res.code == '0') {
                            notification.success({
                                message: '验证码发送成功，请查看邮箱',
                                placement: 'topLeft',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft: `-${that.screenWidth/2-200}px`,
                                    marginTop: `${20}%`,
                                }
                            });
                        } else if (res.code == '1') {
                            notification.success({
                                message: '邮箱不存在，请联系平台管理员补充邮箱',
                                placement: 'topLeft',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft:`-${that.screenWidth/2-200}px`,
                                    marginTop: `${20}%`,
                                }
                            });
                        } else if (res.code == '2') {
                            notification.success({
                                message: '今日验证码已达上限，24小时后重新申请',
                                placement: 'topLeft',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft:`-${that.screenWidth/2-200}px`,
                                    marginTop: `${20}%`,
                                }
                            });
                        } else if (res.code == '3') {
                            notification.success({
                                message: '邮箱功能未开通，联系管理员设置',
                                placement: 'topLeft',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft: `-${that.screenWidth/2-200}px`,
                                    marginTop: `${20}%`,
                                }
                            });
                        } else if (res.code == '4') {
                            notification.success({
                                message: res.msg,
                                placement: 'topLeft',
                                style: {
                                    width: '400px',
                                    fontWeight: '600',
                                    marginLeft:`-${that.screenWidth/2-200}px`,
                                    marginTop: `${20}%`,
                                }
                            });
                        }
                        this.confirmLoading = false;
                        // this.$router.push(this.redirectPath);
                    }).catch((err) => {
                        console.log(err, 'err')
                        this.confirmLoading = false;
                    })
                })
                .catch(() => {
                })
        },
        logout() {
            let self = this;

            self.$ls.clear();
            self.$store.commit('setMenuData', []);
            self.$router.replace('/');

            location.reload();
        },
        onLogout() {
            let self = this;
            self.$confirm({
                title: '确认要退出登录?',
                content: '',
                onOk() {
                    self.postAction({
                        url: login_mp.saveLog,
                        params: {logAppCategoryEnum: "LOGOUT"}
                    }).then(res => {
                        console.log(res)
                        self.getAction({
                            url: login_mp.logout,
                            params: {access_token: ls.get("token") || ""},
                            isValid: false
                        }).then(() => {
                            self.$notification['success']({
                                message: '退出成功',
                                duration: 10,
                                style: {
                                    fontWeight: '600',
                                },
                            });
                        })
                    })


                    setTimeout(() => {
                        self.logout();
                    }, 2000)
                },
                onCancel() {
                },
            });
        },
        getUserInfo() {
            this.getAction({
                url: sys_admin.userInfor
            }).then(res => {
                sessionStorage.setItem("roleCode", res.roleCode.split(','));
            })
        },
        goHttp(url) {
            window.open(url, '_bank')
        },
        goMore(url, str) {
            this.$router.push({path: url, query: {id: str}})
        },
        getDate() {
            this.getAction({
                url: enterpriseOperatingIncome.getDate,
                // params: { id: id },
                returnMsg: true,
            }).then((res) => {
                this.getDateId = res.data
                // auditStatus
            });
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        getNew(e) {
            if (e.target.value != this.form.newpassword) {
                this.pwOk = false
            } else {
                this.pwOk = true
            }
        },
        createCode() {
            const codeChars = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f',
                'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
                'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
                'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z');
            for (var i = 0; i < this.codeLength; i++) {
                var charNum = Math.floor(Math.random() * 62);
                this.code += codeChars[charNum];
            }
        },
        clearCode() {
            this.code = '';
            this.createCode()
        },

        exportExcelTemplate() {
            axios({
                methods: 'get',
                url: register_mp.exportExcelTemplate,
                responseType: 'blob',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    Authorization: 'Bearer' + ls.get('token') || ''
                }
            }).then(data => {
                const blob = new Blob([data.data], {type: "application/docx"});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a"); // 创建a标签
                link.href = url;
                link.download = decodeURIComponent('企业认证承诺授权书.docx');// 文件重命名，若无需重命名，将该行删去
                link.click();
                URL.revokeObjectURL(url); // 释放内存
            })
        },
        heckCode() {
            var inputCode = this.inputvalue;
            if (inputCode.length <= 0) {
                this.show = true
                this.showerror = false
            } else if (inputCode.toUpperCase() != this.code.toUpperCase()) {
                this.showerror = true
                this.show = false
                this.code = ''
                this.createCode();
                // this.inputvalue = "";
            } else {
                this.showerror = false
                this.show = false
            }
        },
        handleChange(e) {
            this.optionsTreeList = null
            this.companyShow = null
            if (e == '004') {
                this.companyShow = 1
            } else if (e == '005') {
                this.optionsTreeList = this.optionsMechanIsmTreeList
            } else if (e == '006') {
                this.optionsTreeList = this.optionsBaseTreeTreeList
            }
        },
        register(values) {

            this.confirmLoading = true;
            this.postAction({
                    url: register_mp.register,
                    params: {
                        phoneNumber: values.phoneNumber,
                        roleId: values.roleId,
                        name: values.username,
                        email: values.email,
                        password: values.password,
                        functionId: values.functionId,
                        companyName: values.companyName,
                        // file: this.form.watmal,
                        licenceFile: values.licenceFile,
                        legalPersonCard: values.legalPersonCard,
                        oraganizationCode: values.oraganizationCode,
                        companyDomain: values.companyDomain,
                        prov: this.addressInfo.province,
                        city: this.addressInfo.city,
                        dist: this.addressInfo.district,
                        detailedAddress: this.addressInfo.address,
                        degreeLongitude: this.addressInfo.longitude,
                        latitude: this.addressInfo.latitude,
                        affiliatedPark: values.affiliatedPark,
                        baseId: values.baseId,
                        idCard: values.idCard,
                        institution: values.institution,
                        positional: values.positional,
                        idCardFile: values.idCardFile,
                        positionalFile: values.positionalFile,
                        applyFile: values.applyFile,
                        file: values.file,
                        legalName: values.legalName
                    }
                }
            ).then(() => {


                notification.open({
                    message: this.form.roleId==='014'?'注册成功，请登录后进行认证！':'注册成功，请等待审核结果！！',
                    duration: 10,
                    placement: 'topLeft',
                    style: {
                        width: '400px',
                        fontWeight: '600',
                        marginLeft: `-${this.screenWidth/2-200}px`,
                        marginTop: `${20}%`,
                    },
                    icon: h(SmileOutlined, {
                        style: 'color: #0fb400',
                    }),
                });

                this.confirmLoading = false;
                this.$router.push(this.redirectPath);
            }).catch((err) => {
                console.log(err, 'err')
                this.confirmLoading = false;
            })
        },

        getinnovationBaseInfo() {
            this.getAction({
                    url: innovationBaseInfo.list,
                }
            ).then((res) => {
                console.log('所属园区', res)
                this.options = res
            })
        },
        getChildrenInnovationBaseInfo(pid) {
          this.getAction({
              url: innovationBaseInfo.childrenList,
              params: {
                id: pid
              }
            }
          ).then((res) => {
            // console.log('所属园区', res)
            this.options2 = res
          })
        },
        subCompanyCode() {
            var valiSome = ['oraganizationCode']
            this.$refs.ruleForm.validate(valiSome).then(() => {
                this.getAction({
                        url: register_mp.VerifyCompanyCode,
                        params: {
                            licence: this.form.oraganizationCode
                        }
                    }
                ).then((res) => {
                    if (res) {
                        this.$notification.success({
                            message: '统一社会信用代码可用，请继续操作',
                            duration: 10,
                            style: {
                                width: '400px',
                                fontWeight: '600',
                                marginTop: `${10}%`,
                            },
                        });
                    } else {
                        this.$notification.error({
                            message: '该统一社会信用代码已注册，无需重新注册，请去【登录页-忘记密码】找回即可',
                            duration: 10,
                            style: {
                                width: '400px',
                                fontWeight: '600',
                                marginTop: `${10}%`,
                            },
                        });
                    }
                })
            })
        },
        subCompanyName() {
            var valiSome = ['companyName']
            this.$refs.ruleForm.validate(valiSome).then(() => {
                this.getAction({
                        url: register_mp.VerifyCompanyName,
                        params: {
                            companyName: this.form.companyName
                        }
                    }
                ).then((res) => {
                    if (res) {
                        this.$notification.success({
                            message: '企业名称可用，请继续操作',
                            duration: 10,
                            style: {
                                width: '400px',
                                fontWeight: '600',
                                marginTop: `${10}%`,
                            },
                        });
                    } else {
                        this.$notification.error({
                            message: '该企业已注册，无需重新注册',
                            duration: 10,
                            style: {
                                width: '400px',
                                fontWeight: '600',
                                marginTop: `${10}%`,
                            },
                        });
                    }
                })
            })
        },
        subPhone() {
            var valiSome = ['phoneNumber']
            this.$refs.ruleForm.validate(valiSome).then(() => {
                this.getAction({
                        url: register_mp.verifyUniquePhone,
                        params: {
                            phoneNumber: this.form.phoneNumber
                        }
                    }
                ).then((res) => {
                    if (res) {
                        this.getPhoneCode()
                        this.$notification.success({
                            message: '手机号可用，请继续操作',
                            duration: 10,
                            style: {
                                width: '400px',
                                fontWeight: '600',
                                marginTop: `${10}%`,
                            },
                        });
                    } else {
                        this.$notification.error({
                            message: ('手机号已存在，请更换手机号'),
                            duration: 10,
                            style: {
                                width: '400px',
                                fontWeight: '600',
                                marginTop: `${10}%`,
                            },
                        });
                    }
                })
            })
        },
        subMail() {
            var valiSome = ['watmal', 'phoneNumber']
            this.$refs.ruleForm.validate(valiSome).then(() => {
                this.postAction({
                        url: phoneCommon.registerSMSCheck,
                        params: {
                            code: this.form.watmal,
                            phone: this.form.phoneNumber
                        }
                    }
                ).then((res) => {
                    if (res) {
                        this.$notification.success({
                            message: '验证码正确，请继续操作',
                            duration: 10,
                            style: {
                                width: '400px',
                                fontWeight: '600',
                                marginTop: `${10}%`,
                            },
                        });
                    } else {
                        this.$notification.error({
                            message: '验证码有误，请输入正确验证码',
                            duration: 10,
                            style: {
                                width: '400px',
                                fontWeight: '600',
                                marginTop: `${10}%`,
                            },
                        });
                    }
                })

            })

        },
        onSubMail(values) {
            this.postAction({
                    url: phoneCommon.registerSMSCheck,
                    params: {
                        code: values.watmal,
                        phone: values.phoneNumber
                    }
                }
            ).then((res) => {
                if (res) {
                    if (this.form.roleId==='014')
                    {
                        this.visible2 = true
                    }else {
                        this.visible = true
                        this.current += 1
                    }

                    this.registerOk = values
                } else {
                    this.$notification.error({
                        message: '验证码有误，请输入正确验证码',
                        duration: 10,
                        style: {
                            fontWeight: '600',
                        },
                    });
                }
            })
        },
        onSubmit() {

            if (this.pwOk == true) {
                if (this.showerror == false && this.show == false) {
                    this.$refs.ruleForm
                        .validate()
                        .then((values) => {
                            this.onSubMail(values)
                            // this.visible = true
                            // this.registerOk = values
                        })
                        .catch(() => {
                        })
                }
            } else {

                this.$notification.warning({
                    message: '密码输入有误！',
                    duration: 10,
                    style: {
                        fontWeight: '600',
                    },
                });
            }
        },

        getRoleTreeList() {
            this.getAction({
                url: register_mp.getRoleTreeList
            }).then((res) => {
                if (this.isReview){
                    this.form.roleId='014'
                    this.optionsRoleTreeList = [
                        {
                            "id": "014",
                            "roleName": "专家"
                        },
                        {
                            "id": "013",
                            "roleName": "事业单位/国企"
                        }
                    ]
                }else{
                    this.optionsRoleTreeList = res
                }
            });
        },
        getMechanIsmTreeList() {
            this.getAction({
                url: register_mp.getMechanIsmTreeList
            }).then((res) => {
                this.optionsMechanIsmTreeList = res
            });
        },
        getBaseTreeList() {
            this.getAction({
                url: register_mp.getBaseTreeList
            }).then((res) => {
                this.optionsBaseTreeTreeList = res
            });
        },
        readBook() {
            this.visible = true
        },
        handleOk() {
            if (this.checkedRadio == true) {
                this.register(this.registerOk)
                this.checkedRadioBtn = false
                this.current += 1
            } else {
                this.checkedRadioBtn = true
            }
        },
        /** 显示地图 */
        showMap() {
            this.$refs.bmapAddressSelect.show();
        },

        /** 确认地图地址 */
        confirmMapAddress(addressInfo) {
            this.addressInfo = addressInfo;
            // this.form.addressStr = addressInfo.province + addressInfo.city + addressInfo.district + addressInfo.address
             this.form.addressStr =  addressInfo.address
        },
        checkIdCardUnique(){
            var valiSome = ['idCard']
            this.$refs.ruleForm.validate(valiSome).then(() => {
                this.postAction({
                    url: register_mp.verifyUniqueIdCard,
                    params: {card: this.form.idCard},
                }).then((resp)=>{
                    if (!resp){
                        this.$notification.error({
                            message: '身份证号已被注册',
                            duration: 10,
                            style: {
                                fontWeight: '600',
                            },
                        });
                    }else{
                        this.$notification.success({
                            message: '身份证号可用',
                            duration: 10,
                            style: {
                                fontWeight: '600',
                            },
                        });
                    }
                })
            })
        }
    },
    watch: {
        checkedRadio(val) {
            if (val) {
                this.checkedRadioBtn = false
            } else {
                this.checkedRadioBtn = true
            }
        },
        "form.roleId"(){
            this.rules.addressStr = [dataCheck.required({msg: this.companyName+'地址不能为空'})]
            this.rules.companyName = [dataCheck.required({msg: this.companyName+'名称不能为空'})]
            this.rules.licenceFile = [dataCheck.required({msg: this.fileLabel+'不能为空'})]
        }
    },
    mounted() {
        if (this.$route.query.id==='review') {
            this.isReview = true;
        }

        this.useExpertByQueryStr()
        this.getinnovationBaseInfo()
        this.getRoleTreeList()
        this.getMechanIsmTreeList()
        this.getBaseTreeList()
        this.createCode();
        // this.getDate()
        if (ls.get('token') && ls.get("refresh_token")) {
            this.user.userName = this.$ls.get('userName')
            this.user.phoneNumber = this.$ls.get('phoneNumber')
        }
        this.all_logo = this.$ls.get('all_logo');
        this.screenWidth=screen.width
    },
    beforeCreate() {
        // 修改背景色
        document.querySelector('body').setAttribute('style', 'background-color:#fff')
    },
    beforeUnmount() {
        // 销毁背景色
        document.querySelector('body').removeAttribute('style')
    },

}
</script>
<style>
</style>
<style scoped lang="less">
:deep(.ant-input),
:deep(.ant-input-affix-wrapper),
:deep(.ant-select:not(.ant-select-customize-input) .ant-select-selector){
    background: #f7f9fc;
    border:none;
}
.button{
    background: #0059B5;
    color:#fff;
    width: 260px;
    display: block;
    margin:20px auto;
    height: 50px;
    font-size: 20px;
    border:none;
}
.select-role{
    padding:0 30px;
    .role-box{
        // display:flex;
        // //justify-content: space-between;
        // flex-wrap: wrap;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 20px;
        .item-active{
            color: #0257AB !important;
            font-weight: bold !important;
            border-color:#0257AB !important;
        }
        .item{
            // width: 23.5%;
            text-align: center;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            // margin: 0 20px 20px 0;
            background: #f7f9fc;
            padding:30px 0;
            cursor: pointer;
            border:1px solid #f7f9fc;
            box-sizing:border-box;
            border-radius: 4px;
            img{
                height: 50px;
                margin-bottom: 10px;
            }
        }
    }
}
.codeBtnWordMark {
    width: 100%;
    height: 40px;
    background: rgba(136, 135, 135, 0.6);
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
}

.headerBox {
    width: 100%;
    height: 92px;
    background-color: #f3f4f9;
    .home{
        font-size: 14px;
        padding:2px 0;
    }
    .right {
        display: flex;
        background: rgba(0, 89, 181, 0.1);
        padding:0 20px;
        border-radius: 50px;
        cursor: pointer;
        font-size: 16px;

        .login {
            margin-right: 20px;
            position: relative;
            img {
                width: 13px;
                height: 15px;
                margin-right: 2px;
                margin-bottom: 1px;
            }
        }

        .login::after {
            position: absolute;
            content: '';
            width: 1px;
            display: block;
            height: 14px;
            left: 60px;
            top: 5px;
            background: #375d72;
        }
    }

    .hearderContentBox {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .titleBox {
            cursor: pointer;
            overflow: hidden;
            float: left;
            line-height: 92px;
            font-size: 30px;
            font-weight: bold;
            width: 60%;
            .logoBox {
                float: left;
                margin-right: 5px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .rightBox {
            float: right;
            display: flex;
            justify-content: space-around;
            line-height: 92px;
            font-size: 16px;

            a {
                font-weight: 600;
            }

            .loginBox {
                // float: left;
                cursor: pointer;
            }

            .loginBox:hover {
                color: #fc550b;
            }

            .lineBox {
                height: 18px;
                top: 36px;
            }

            .resigierBox {
                cursor: pointer;
                // float: left;
            }

            .resigierBox:hover {
                color: #fc550b;
            }
        }
    }
}

.bannerBox {
    position: relative;
    width: 100%;

    :deep(.ant-carousel) {
        position: relative;
        width: 100%;
    }

    .bannerImg {
        width: 100%;
        height: 282px;

        img {
            width: 100%;
            object-fit: cover;
            height: 280px;
        }
    }
}


.floatBox {
    width: 100%;

    .textBox {
        width: 100%;
        height:600px;
        line-height: 40px;
        background-image: url('../assets/home/login-bj.png');
        background-size: 100% 100%;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        justify-content: center;

        .text {
            font-size: 40px;
            color: #fff;
            font-weight: 700;
            padding-top:100px;
        }
    }

    .midBox {
        position: relative;
        width: 100%;
        min-height: 50vh;

        .midFloatBox {
            overflow: hidden;
            width: 1200px;
            height: 100%;
            padding: 10px 15px 25px;
            margin: -420px auto 40px auto;
            background-color: #fff;
            box-shadow: 0 10px 15px rgba(39, 69, 167, .2);
            border-radius: 5px;

            .breadBox {
                // width: 1200px;
                margin: 3px 0 15px;
                font-size: 16px;
            }

            .tabBox {
                overflow: hidden;
                width: 100%;
                min-height: calc(100vh - 400px);
                margin: 0 auto;

                .code {
                    text-align: center;
                    height: 30px;
                    background: #e2e2e2;
                    line-height: 30px;
                    font-size: 24px;
                }

                .layout-header {
                    background-color: #ffffff;
                    height: auto;
                    padding-top: 30px;
                }

                //
                //.layout-content {
                //  background: url(../assets/img/login-bg.png) center center no-repeat #ffffff;
                //  padding: 60px 0;
                //}

                .layout-footer {
                    background-color: #ffffff;
                }

                .container {
                    //width: 90%;
                    //height: 80%;
                    margin-left: auto;
                    margin-right: auto;
                    padding-top: 30px;
                    //padding-top: 48%;
                    //background: url(../assets/img/login-image.png) center center no-repeat;
                    //background-size: 80%;

                }

                .login-form {
                    width: 70%;
                    margin: 40px auto;

                    h3 {
                        margin: 0 0 30px;
                        position: relative;
                        padding-left: 15px;

                        span {
                            position: absolute;
                            left: 0;
                            display: block;
                            height: 60%;
                            top: 20%;
                            width: 4px;
                            background: #1890ff;
                        }
                    }

                    .btnBB {
                        display: flex;
                        justify-content: center;
                        .button{
                            margin:0;
                        }
                        .button1{
                            border:1px solid #0059b5;
                            color: #0059b5;
                            width: 260px;
                            display: block;
                            height: 50px;
                            font-size: 20px;
                        }
                    }

                    :deep(.ant-form-item-label > label) {
                        font-size: 16px;
                    }
                }

                .ant-col-10 {
                    margin-top: -43%;
                    margin-left: 12%;
                }

                .title {
                    font-size: 60px;
                    font-weight: 500;
                    margin: 40px 0;
                }


                .vcode-img {
                    display: block;
                    width: 100%;
                    height: 50px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .login-img {
                    display: block;
                    width: 100%;
                }

            }
        }

    }
}

:deep(.ant-list-lg .ant-list-item) {
    padding: 16px 8px;
}

::v-deep .ant-input-group-addon{
    background: #0059b5;
    color:#fff;
    border:none;
}
::v-deep .ant-steps-item-icon{
    display: none;
}
::v-deep .ant-steps-item-title{
    font-size: 22px;
}
.ant-steps-navigation .ant-steps-item::before{
    bottom:-9px;
}
::v-deep .ant-steps-navigation .ant-steps-item.ant-steps-item-active::before{
    background: #0059b5;
}
::v-deep .ant-steps-item-active .ant-steps-item-title{
    color:#0059b5 !important;
}
::v-deep .ant-steps-item-title:hover{
    color:#0059b5 !important;
}
::v-deep .ant-steps{
    margin-bottom: 40px !important;
    padding-bottom: 10px;
}
::v-deep .ant-notification{
    right:50% !important;
    transform:translateX(50%) !important;
}

</style>
